import type { Content } from '../../models';

import { MapTypes, VisualsWithDataTypes } from '../../config/constants';

export const validateContentVersion71 = (content: Content): boolean => {
  const { type, typeSpecific } = content;

  if (typeSpecific.version < 71) {
    if ((VisualsWithDataTypes.includes(type) || MapTypes.includes(type)) && typeSpecific.map) {
      if (!typeSpecific.map.miniMap?.view) {
        typeSpecific.map.miniMap = {
          enabled: typeSpecific.map.miniMap?.enabled ?? false,
          text: typeSpecific.map.miniMap?.text ?? undefined,
          position: 'bottom-right',
          width: 80,
          height: 80,
          view: 'globe',
          background: {
            backgroundColor: 'rgba(255,255,255,0)',
          },
          boxShadow: {
            x: 0,
            y: 0,
            blur: 0,
            color: 'transparent',
            spread: 0,
          },
          offsetX: 10,
          offsetY: 10,
          lineColor: '#ff0000',
          lineWidth: 1,
          fillColor: 'rgba(255,0,0,0.2)',
          borderRadius: 3,
          choros: {
            fillColor: '#ddd',
            lineColor: '#fff',
            lineWidth: 1,
          },
        };
      }
    }

    // typeSpecific.version = 71;
  }

  return true;
};
